import {
  PATCH_ADMIN_BALANCE_AFTER_TRANSFER,
  PATCH_SUPER_STOKEZ_BALANCE_AFTER_TRANSFER,
  PATCH_STOKEZ_BALANCE_AFTER_TRANSFER,
  PATCH_AGENT_BALANCE_AFTER_TRANSFER,
  PATCH_PLAYER_BALANCE_AFTER_TRANSFER,
} from '../actions/transferBalancePatchActions';

/**
 * Updates the recipient row in the matching list slice after transferBalance API success.
 * @param {import('redux').Dispatch} dispatch
 * @param {{ toRole?: string, toId?: string, newRecipientBalance?: number }} transferResult
 */
export function applyRecipientBalancePatch(dispatch, transferResult) {
  if (!transferResult || transferResult.toId == null) return;
  const bal = Number(transferResult.newRecipientBalance);
  if (!Number.isFinite(bal)) return;

  const toId = transferResult.toId;
  const raw = String(transferResult.toRole || '').toLowerCase().replace(/_/g, '');

  if (raw === 'admin') {
    dispatch({ type: PATCH_ADMIN_BALANCE_AFTER_TRANSFER, payload: { username: toId, balance: bal } });
    return;
  }
  if (raw === 'superstokez') {
    dispatch({ type: PATCH_SUPER_STOKEZ_BALANCE_AFTER_TRANSFER, payload: { username: toId, balance: bal } });
    return;
  }
  if (raw === 'stokez') {
    dispatch({ type: PATCH_STOKEZ_BALANCE_AFTER_TRANSFER, payload: { username: toId, balance: bal } });
    return;
  }
  if (raw === 'agent') {
    dispatch({ type: PATCH_AGENT_BALANCE_AFTER_TRANSFER, payload: { username: toId, balance: bal } });
    return;
  }
  if (raw === 'player') {
    dispatch({ type: PATCH_PLAYER_BALANCE_AFTER_TRANSFER, payload: { playerId: toId, balance: bal } });
  }
}
